import widgets from './widgets'

export default {
    widgets
}